import { Box, Collapse, Tab, Tabs, Typography } from '@mui/material';
import React, { useState } from "react";
import { Conductoresview } from "./ConductoresView";
import { VehiculosView } from "./VehiculosView";
import styled from "@emotion/styled";

const ContainerSubTable = styled.div`
padding:10px;`;

export const SubTableProveedores = ({
    opened,
    parentData

})=>{
    
    const [tabIndex,setTabIndex] = useState(0);

    return (
        <Collapse
        in={opened}
        unmountOnExit
        >

<Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={tabIndex} onChange={(evt,val)=>setTabIndex(val)} aria-label="tab control proveedores">
          <Tab  label="Conductores" id='0'  />
          <Tab label="Vehiculos" id="1"  />
         
        </Tabs>
      </Box>
       <ContainerSubTable>
          {tabIndex === 0?<Conductoresview parentData={parentData} />:<VehiculosView parentData={parentData} />}
       </ContainerSubTable>
    </Box>
        
        </Collapse>
    )

}
